import { Button } from '@deckee/deck-hand';
import React, { FC } from 'react';
import usePaywall from '../../../../hooks/use-paywall';
import PromoCard from '../../../../shared/PromoCard/PromoCard';
import { trackExtendedForecastCtaCardTapped } from '../../helpers/analytics/extendedForecastAnalytics';
import forecastCtaImage from '../../assets/forecast-cta.png';

const ExtendedForecastCtaCard: FC = () => {
  const { presentPaywall } = usePaywall('Extended weather forecast');

  const handleClick = () => {
    trackExtendedForecastCtaCardTapped();
    presentPaywall();
  };

  return (
    <PromoCard
      data-testid="weather-forecast-extended-cta-card"
      imageSrc={forecastCtaImage}
      title="Plan even further ahead"
      description="Most days on the water get planned a week or more out. Your boating forecast can go that far too."
    >
      <Button wide onClick={handleClick}>
        Get 15 day forecasts
      </Button>
    </PromoCard>
  );
};

export default ExtendedForecastCtaCard;
